<template>
	<q-card style="width: 700px; max-width: 80vw;">
		<q-card-section>
			<MediaLibrary
				:is_message_forms="true"
			/>
		</q-card-section>
		<q-card-actions class="justify-end">
			<q-btn flat label="Cancel" color="primary" @click="$emit('close');" />
			<q-btn flat label="Attach" color="primary" @click="saveChoiceFromLibrary()" />
		</q-card-actions>
	</q-card>
</template>

<script>
import MediaLibrary from "@/views/MediaLibrary.vue";
import { mapGetters } from 'vuex';
export default {
	name: 'MediaLibraryModal',
	components:{
		MediaLibrary
	},
	computed:{
		...mapGetters([ 'selected_files' ])
	},
	methods:{
		saveChoiceFromLibrary(){
			if (!this.selected_files.length){
				this.$q.notify({
					timeout: 6700,
					message: 'Please select a file to attach.',
					actions: [
						{
							label: 'Dismiss',
							color: 'primary',
						},
					],
				})
				return
			}
			this.$emit('choose-media-file', this.selected_files);
		},
	},
}
</script>
